module.exports = __webpack_public_path__ + "img/banner-tc2-m.cdc683b1.jpg";